import { useContext, useRef, useState, useEffect } from "react"
import UserContext from "../context/UserContext"
import styles from '../styles/Lesson.module.css'
import LessonIntroduction from "../components/common/AssignableIntroduction"
import { useSoundManager } from "../utils/sound"
import AssignableRIO from "../components/assignables/AssingableRIO"
import { axios, uploadToS3 } from "../resources/api"
import { cn } from "../utils/utils";
import { pauseAll } from "../utils/audios";
import { playSound } from "../utils/playsound";
import { waitForWcpmReveal, resolveWcpmReveal } from "../utils/wcpmRevealGate";
import { WCPM_CELEBRATION_AUDIO } from "../const/wcpmCelebrationAudio";

async function playCelebrationUrl(url) {
    if (!url) return;
    await new Promise((resolve) => {
        const a = new Audio(url);
        const done = () => resolve();
        a.addEventListener("ended", done);
        a.addEventListener("error", done);
        a.play().catch(done);
    });
}
import ResultPage from "../components/common/ResultPage"
import { useNavigate } from "react-router-dom"

export const Assignable = () => {
    const { user } = useContext(UserContext)
    /**
   * @type {{passage: string[], grade: string, key: string}} | undefined
   */
    const data = user.assignable;
    const passageId = data?.key.replace("P", "");
    const [page, setPage] = useState("introduction");
    const soundManager = useSoundManager();
    const [status, setStatus] = useState(null);
    const [sentenceResults, setSentenceResults] = useState({});
    const s3FieldsRef = useRef(null);
    const audioBlob = useRef(null);
    const metaBlob = useRef(null);
    const wordCount = data?.passage.join(" ").split(" ").length
    const navigate = useNavigate()

    const [wasSuccessful, setWasSuccessful] = useState(false)

    const [resp, setResp] = useState(null);
    const [wcpmRevealPayload, setWcpmRevealPayload] = useState(null);

    useEffect( () => {
        if (!resp) return;
        
        const handleResponse = async () => {
            if (resp.wcpmReveal) {
                setWcpmRevealPayload(resp.wcpmReveal);
                setStatus("wcpmReveal");
                await waitForWcpmReveal();
                const celebrationMap = {
                    wasGreat: WCPM_CELEBRATION_AUDIO.wasGreat,
                    personalBest: WCPM_CELEBRATION_AUDIO.personalBest,
                    leveledUp: WCPM_CELEBRATION_AUDIO.leveledUp,
                    leveledUpTo8: WCPM_CELEBRATION_AUDIO.leveledUpTo8,
                };
                const cel = resp.wcpmReveal.celebration;
                if (cel && celebrationMap[cel]) {
                    await playCelebrationUrl(celebrationMap[cel]);
                }
                await pauseAll();
                setWcpmRevealPayload(null);
                if (resp.isCorrect === true) {
                    setStatus("pass");
                    playSound("correct").then(() => window.location.reload());
                } else if (resp.tryAgain === true && resp.isCorrect === false) {
                    setStatus("fail");
                    setSentenceResults({}); // clear the previous attempt's green/red marks before the retry
                    playSound("wrong").then(() => setStatus("started"));
                } else if (resp.tryAgain === false && resp.isCorrect === false) {
                    setStatus("fail");
                    playSound("wrong").then(() => window.location.reload());
                }
                return;
            }
            if (resp.isCorrect === true) {
                setStatus("pass");
                await pauseAll()
                playSound("correct").then(r =>  window.location.reload())
                
            } else if(resp.tryAgain === true && resp.isCorrect === false) {
                setStatus("fail");
                setSentenceResults({}); // clear the previous attempt's green/red marks before the retry
                await pauseAll()
                playSound("wrong").then(r=> setStatus("started"))

            }else if(resp.tryAgain === false && resp.isCorrect === false){
                setStatus("fail");
                await pauseAll()
                playSound("wrong").then(r=> window.location.reload())
               
            }else{

            }
        };
       

        handleResponse();
    }, [resp]);

    return (
        <div className={cn(styles.container, " !overflow-hidden")}>
            <head>
                <title>Checkpoint</title>
            </head>
            <div className={styles.lessonInformation}>
                <span><b>Checkpoint Passage {passageId}</b>&nbsp; &nbsp; {data?.lexile}</span>
            </div>
            {page == 'introduction' && (
                <LessonIntroduction
                    lessonId={0}
                    onNext={() => {
                        setPage("lesson")
                    }}
                    passageId={passageId}
                    grade={data?.grade}
                    wordCount={wordCount}
                    key={data?.key}
                    lexile={data?.lexile}
                    trialId={"trialId"}
                    soundManager={soundManager}
                />
            )}
            {
                page === "lesson" && data && <AssignableRIO
                    data={data}
                    current={0}
                    soundManager={soundManager}
                    status={status}
                    setStatus={setStatus}
                    wcpmReveal={status === "wcpmReveal" ? wcpmRevealPayload : null}
                    onWcpmComplete={() => resolveWcpmReveal()}
                    questionIndex={0}
                    sentenceResults={sentenceResults}
                    setSentenceResults={setSentenceResults}
                    metaBlob={metaBlob}
                    audioBlob={audioBlob}
                    questions={data?.passage}
                    s3FieldsRef={s3FieldsRef}
                    itemDetails={{
                        type: "rio",
                        text: data?.passage.map(itm => itm.replace(/\s+/g, " "))
                    }}
                    subType={"assignable"}
                    isParagraphRIO={false}
                    clickHandler={async () => {
                        const { url, uploadId } = s3FieldsRef.current
                        let isUploaded = false;
                        if (audioBlob.current) {
                            const res = await uploadToS3(url, audioBlob.current, "audio.wav", "audio/x-wav");
                            isUploaded = true;
                        }
                        const res=(await axios.post(`/student/assignableCheckpoint/submit`, {
                            uploadId,
                            textId: data?.key,
                            grade: data?.grade,
                            meta: metaBlob.current,
                            trialId: data.trialId
                        })).data;

                        setResp(res);

                        
                    }}
                />
            }
            {
                page === "result" && <ResultPage wasSuccessful={
                    wasSuccessful
                } percentage="10%" lessonId="1" checkpoint={true} homePage={() => navigate("/")} />
            }
        </div>
    )
}